import { useRef } from "react";
import { CancelButton } from "./CancelButton";
import { SaveButton } from "./SaveButton";
import { EditingInput } from "./EditingInput";

/** The container component for the editing modal */

export function EditingModal({ text, setIsEditing, project_id, setCurrentText }: { text: string; setIsEditing: (isEditing: boolean) => void; project_id: string; setCurrentText: (text: string) => void; }) {
    const oldText = useRef(text);

    return (
        <div className="flex flex-col gap-2">
            <EditingInput text={text} setCurrentText={setCurrentText} />

            <div className="flex gap-2">
                <CancelButton setIsEditing={setIsEditing} setCurrentText={setCurrentText} oldText={oldText} />
                <SaveButton setIsEditing={setIsEditing} project_id={project_id} setCurrentText={setCurrentText} current_text={text} />
            </div>
        </div>
    );
}
